import {apiCall} from "./apicall";

export async function fetchCards(){
    return await apiCall("/cards")
}

export async function fetchCard(id){
    return await apiCall("/cards/"+id);
}

export async function fetchCardOffers(id){
    return await apiCall("/cards/offers/"+id);
}

export async function createCard(){
    return await apiCall("/cards", {method: "POST"});
}

export async function removeCard(id){
    return await apiCall(`/cards/${id}`, {method: "DELETE"});
}

export async function updateCard(body){
    return await apiCall(`/cards/${body.CardID}`, {method: "PUT"}, body);
}

export async function addOfferToCard(CardID, OfferID){
    return await apiCall("/cards/offers/"+CardID, {method: "POST"}, {OfferID});
}

export async function removeOfferFromCard(CardID, OfferID){
    return await apiCall("/cards/offers/"+CardID, {method: "DELETE"}, {OfferID});
}

export async function getCardCodes(CardID){
    return await apiCall(`/cards/${CardID}/codes`, {method: "GET"});
}
